export default __webpack_public_path__ + "static/media/widget-decrease.89849a3d.svg";